export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7693.75bb4611.jpg";